<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    displayClear: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    dropDownSizeMatches: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    sortItems: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    fixedPosition: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    displayErrorMessage: {
      type: Boolean,
      default: false,
    },
    validationErrorMessage: {
      type: String,
      default: '',
    },
    prefixText: {
      type: String,
      default: '',
    },
    noPlaceholder: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: undefined,
    },
    onExpandMenu: {
      type: Function,
      default: () => {},
    },
    onCollapseMenu: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
